import { css } from 'styled-components/macro';

export const disablePrint = css`@media print { display: none; }`;
